import { inject, Injectable } from '@angular/core';
import { type GoalCardsQueryQueryVariables, type WorkspaceFilter } from '@reconcept-platform/shared/types';
import { SubDomainApi } from '../../api/sub-domain/sub-domain.api';
import { GoalCardService } from '../cards/goal-card/goal-card.service';

@Injectable({
  providedIn: 'root',
})
export class SubDomainService {
  private subDomainApi = inject(SubDomainApi);
  private goalService = inject(GoalCardService);

  getSubDomainTitle(subDomainId: string) {
    return this.subDomainApi.getSubDomainTitle(subDomainId);
  }

  watchSubDomainWithSeverity(subDomainId: string, workspaceFilter: WorkspaceFilter) {
    return this.subDomainApi.watchSubDomainWithSeverity(subDomainId, workspaceFilter);
  }

  watchSubDomainGoalCardTiles(goalCardsFilter: GoalCardsQueryQueryVariables) {
    return this.goalService.watchGoalCards(goalCardsFilter);
  }
}
